import React from 'react';
import MicroLoan from '../assets/loanIcons/Micro-loan.webp'
import SMELoan from '../assets/loanIcons/SME-loan.webp'
import BusinessLoan from '../assets/loanIcons/Business-loan.webp'
import HomeLoan from '../assets/loanIcons/Home-loan.webp'
import PersonalLoan from '../assets/loanIcons/Personal-loan.webp'
import PropertyLoan from '../assets/loanIcons/Property-loan.webp'
import VehicleLoan from '../assets/loanIcons/vehicle-loan.webp'
import { MdOutlineCurrencyRupee, MdOutlineSecurity } from "react-icons/md";
import { BiLike } from "react-icons/bi";
import { IoPhonePortraitOutline } from "react-icons/io5";

const Home = ({ MarginTop }) => {

    return (
        <section id="home" style={{ scrollMarginTop: MarginTop }}>
            <div className='home-section our_services_sec'>
                <h2 className='title'>Welcome to BWE Capital</h2>
                <p>BWE Capital specializes in Bank Correspondence services, serving as an authorized representative for leading financial institutions.
                    Through our bank correspondence network, we facilitate essential banking services on behalf of major banks,
                    extending their reach to communities and businesses that benefit from localized financial access.</p>
                <p>BWE Capital acts as the vital link between premier banking institutions and the customers they serve. We maintain the highest
                    standards of compliance, security, and customer service while operating within the regulatory framework established by
                    our partner banks and financial authorities. Our correspondent services enable banks to reach new markets efficiently
                    while ensuring customers receive professional, reliable banking support.</p>
                <h4 className='sub-title'>Our Service</h4>
                <p>
                    Embark on a financial journey with BWE, where innovation meets reliability. As a leading FinTech Platform, BWE is the result
                    of collaboration among forward-thinking individuals committed to solving challenges for both borrowers and lenders.
                </p>
                <div className="row row-center">
                    <div className="col-xl-3 col-lg-3 col-md-4 col-sm-6 col-6 sm-50 col-sm-6">
                        <a href="https://bwefinserv.in/" target="blank">
                            <div className="our_services_card">
                                <div className="our-service-img"><img loading="lazy" src={MicroLoan} width="100" height="100" alt="img" /></div>
                                <div className="our-service-contents"><h2>Micro Loan</h2></div>
                            </div>
                        </a>
                    </div>
                    <div className="col-xl-3 col-lg-3 col-md-4 col-sm-6 col-6 sm-50 col-sm-6">
                        <a href="https://bwefinserv.in/" target="blank">
                            <div className="our_services_card">
                                <div className="our-service-img"><img loading="lazy" src={SMELoan} width="80" height="100" alt="img" /></div>
                                <div className="our-service-contents"><h2>SME Loan</h2></div>
                            </div>
                        </a>
                    </div>
                    <div className="col-xl-3 col-lg-3 col-md-4 col-sm-6 col-6 sm-50 col-sm-6">
                        <a href="https://bwefinserv.in/" target="blank">
                            <div className="our_services_card">
                                <div className="our-service-img"><img loading="lazy" src={BusinessLoan} width="100" height="100" alt="img" /></div>
                                <div className="our-service-contents"><h2>Business Loan</h2></div>
                            </div>
                        </a>
                    </div>
                    <div className="col-xl-3 col-lg-3 col-md-4 col-sm-6 col-6 sm-50 col-sm-6">
                        <a href="https://bwefinserv.in/" target="blank">
                            <div className="our_services_card">
                                <div className="our-service-img"><img loading="lazy" src={HomeLoan} width="100" height="100" alt="img" /></div>
                                <div className="our-service-contents"><h2>Home Loan</h2></div>
                            </div>
                        </a>
                    </div>
                    <div className="col-xl-3 col-lg-3 col-md-4 col-sm-6 col-6 sm-50 col-sm-6">
                        <a href="https://bwefinserv.in/" target="blank">
                            <div className="our_services_card">
                                <div className="our-service-img"><img loading="lazy" src={PersonalLoan} width="100" height="100" alt="img" /></div>
                                <div className="our-service-contents"><h2>Personal Loan</h2></div>
                            </div>
                        </a>
                    </div>
                    <div className="col-xl-3 col-lg-3 col-md-4 col-sm-6 col-6 sm-50 col-sm-6">
                        <a href="https://bwefinserv.in/" target="blank">
                            <div className="our_services_card">
                                <div className="our-service-img"><img loading="lazy" src={PropertyLoan} width="100" height="100" alt="img" /></div>
                                <div className="our-service-contents"><h2>Property Loan</h2></div>
                            </div>
                        </a>
                    </div>
                    <div className="col-xl-3 col-lg-3 col-md-4 col-sm-6 col-6 sm-50 col-sm-6">
                        <a href="https://bwefinserv.in/" target="blank">
                            <div className="our_services_card">
                                <div className="our-service-img"><img loading="lazy" src={VehicleLoan} width="100" height="100" alt="img" /></div>
                                <div className="our-service-contents"><h2>Vehicle Loan</h2></div>
                            </div>
                        </a>
                    </div>
                </div>

                <h4 className='sub-title'>Why BWE?</h4>
                <p>
                    At BWE, we define financial inclusion as more than just accessibility; it's about empowering individuals and businesses with
                    meaningful, affordable financial solutions. From seamless transactions and secure payments to flexible savings, responsible credit,
                    and reliable insurance, we are dedicated to delivering a comprehensive and sustainable approach. Join us on a journey where financial
                    inclusion is not just a goal but a commitment upheld with responsibility, security, and sustainability.
                </p>
                <div className='row'>
                    <div className='col-lg-6 col-md-12'>
                        <div className='why-box-cont-flx'>
                            <div> <MdOutlineCurrencyRupee /></div>
                            <div>
                                <h5 className='cont-title'>Smart Loan Selection</h5>
                                <p>
                                    Borrowers can choose from various options available; the platform suggests the best rate for the given credentials
                                    of the borrower, thereby ensuring appropriate loan is provided at the lowest rate of interest.
                                </p>
                            </div>
                        </div>
                    </div>
                    <div className='col-lg-6 col-md-12'>
                        <div className='why-box-cont-flx'>
                            <div> <BiLike /></div>
                            <div>
                                <h5 className='cont-title'>Accelerated Approvals</h5>
                                <p>
                                    BWE ensures the loan application is approved at the shortest time frame, with its intelligent technology providing the
                                    optimal options to the lenders for speedy approval by the Banks & NBFCs’.
                                </p>
                            </div>
                        </div>
                    </div>
                    <div className='col-lg-6 col-md-12'>
                        <div className='why-box-cont-flx'>
                            <div> <IoPhonePortraitOutline /></div>
                            <div>
                                <h5 className='cont-title'>Digital Harmony</h5>
                                <p>
                                    As the entire process is digital, the transactions between the borrower & lender are paperless, which provides better
                                    transparency, complete and live status to both borrowers & lenders.
                                </p>
                            </div>
                        </div>
                    </div>
                    <div className='col-lg-6 col-md-12'>
                        <div className='why-box-cont-flx'>
                            <div> <MdOutlineSecurity /></div>
                            <div>
                                <h5 className='cont-title'>Fortress of Financial Security</h5>
                                <p className='mbl-mb-0'>
                                    The transactions are safe & secure with world className security features built into the platform. The entire loan application
                                    process is secure & transparent without any hidden charges.
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default Home;